import * as React from "react";
import {Button, ButtonProps, Spinner, SpinnerSize} from "@vebox/etui-core";

interface LoadingButtonProps {
    loading?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps & ButtonProps> = ({loading, children, ...buttonProps}) => {

    const [isLoading, setIsLoading] = React.useState<boolean>();

    const interceptOnClick = (e) => {
        if (buttonProps.onClick) {
            buttonProps.onClick(e);
        }
        if (loading === undefined) { // If components isn't controlled
            setIsLoading(true);
        }
    };

    React.useEffect(() => setIsLoading(loading), [loading]);

    return (
        <Button {...buttonProps} disabled={isLoading || buttonProps.disabled} onClick={interceptOnClick}>
            {isLoading && <Spinner isInline={true} size={SpinnerSize.xSmall} styles={{root: {mr: 10}}}/>}
            {children}
        </Button>
    )
}